/**
 * Store of app
 * @description Store of app
 * @author Zhong Li
 * @version 1.0.0
 * @since v1.0.0
 */

const state = {
  tagView: {
    activated: [],
  },
};

const mutations = {
  addActivated: (state, view) => {
    if (state.tagView.activated.some((v) => v.path === view.path)) return;
    state.tagView.activated.push(view);
  },

  delActivated: (state, view) => {
    for (const [i, v] of state.tagView.activated.entries()) {
      if (v.path === view.path) {
        state.tagView.activated.splice(i, 1);
        break;
      }
    }
  },
  cleanActivated: (state) => {
    state.tagView.activated = [];
  },
};

const actions = {
  addActivated: ({ commit }, view) => {
    commit("addActivated", view);
  },

  delActivated: ({ commit }, view) => {
    commit("delActivated", view);
  },
  cleanActivated: ({ commit }) => {
    commit("cleanActivated");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
